import { friendlyErrorMessage } from '@/core/lib/dbError'
import { transcribeOnGate, type TranscribeContext, type ExtractionTranscript } from '@/core/api/extraction'
import { blobToBase64 } from '@/core/api/http'
import { ok, technical, type Result } from './result'

export type Dictation = ExtractionTranscript

export async function transcribeAudio(
  audio: Blob,
  opts: TranscribeContext = {},
): Promise<Result<Dictation>> {
  const audioBase64 = await blobToBase64(audio)
  try {
    const data = await transcribeOnGate(audioBase64, audio.type || 'audio/webm', opts)
    if (typeof data?.text !== 'string') return technical("Unerwartete Antwort vom Diktier-Server.")
    return ok(data)
  } catch (error) {
    return technical(friendlyErrorMessage(error, "Die Aufnahme konnte nicht verarbeitet werden. Bitte versuchen Sie es erneut."))
  }
}
